import { useRef } from 'react';
import cloneDeep from 'lodash/cloneDeep';
import isEqual from 'lodash/isEqual';

/**
 * useDeepCompareMemoize is a hook that memoizes a value using a deep comparison.
 *
 * @param value - The value to memoize.
 * @returns The memoized value.
 */
export const useDeepCompareMemoize = <T extends object | undefined,>(value: T): T => {
  const ref = useRef<{
    v: T;
  }>(null);
  if (ref.current == null || !isEqual(value, ref.current.v)) {
    ref.current = {
      v: cloneDeep(value)
    };
  }
  return ref.current.v;
};